export const HOME = "/";
export const BROWSE = "/browse";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
